import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import React from 'react'
import { TableVirtuoso } from 'react-virtuoso';
import RowNoFound from './RowNoFound';

const VirtualizedTable = (props) => {
    const {
        tableData = [],
        columnDefs = [],
        totalColumnDef = [],
        tableLayout = 'fixed',
    } = props
    const VirtuosoTableComponents = {
        Scroller: React.forwardRef((props, ref) => (
            <div {...props} ref={ref} />
        )),
        Table: (props) => (
            <Table {...props} size="small" stickyHeader
                className='tableCommomSection'
                style={{
                    tableLayout: tableLayout, width: '100%',
                    border: ' 1px solid #00000033',
                    borderRadius: '4px',
                    borderCollapse: 'separate',
                    borderSpacing: 0,
                    overflowX: 'scroll',
                    maxWidth: '100%',
                }}
            />
        ),
        TableHead,
        TableRow,
        TableBody: React.forwardRef((props, ref) => (
            <TableBody {...props} ref={ref} />
        )),
    };
    const headerContent = () => (
        <>
            <TableRow>
                {columnDefs.map((col, index) => (
                    <TableCell
                        key={`${col.headerName}-${col.field}-${index}`}
                        sx={{
                            ...col.headerSx,
                            fontWeight: 600,
                            fontStyle: 'normal',
                            lineHeight: '12px',
                            letterSpacing: '2%',
                            color: '#000000',
                            backgroundColor: '#CCE7FF',
                            whiteSpace: 'nowrap',


                        }}
                    >
                        {col.headerName}
                    </TableCell>
                ))}
            </TableRow>
        </>
    )
    const bodyContent = (index, obj) => {
        if (tableData.length === 0) {
            return (
                <RowNoFound colSpan={columnDefs?.length} />
            );
        }
        return (
            <>
                {obj.isTotalRow ?
                    totalColumnDef.map((col, colIndex) => (
                        <TableCell
                            key={`totalRow-${col.field}-${index}-${colIndex}`}
                            colSpan={col?.colSpan || 1}
                            sx={{
                                ...col.headerSx,
                                backgroundColor: '#F1F1F1',
                                fontFamily: 'Roboto',
                                fontWeight: 500,
                                fontStyle: 'normal',
                                fontSize: '12px',
                                lineHeight: '16px',
                                letterSpacing: '2%',
                                color: '#000000',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}
                        >
                            {obj?.[col.field] ?? ''}
                        </TableCell >
                    ))
                    : obj.isSubHeadingRow ?
                        obj.subHeadingData.map((col, colIndex) => (
                            <TableCell
                                key={`subHeading-${col.field}-${index}-${colIndex}`}
                                colSpan={col?.colSpan || 1}
                                sx={{
                                    backgroundColor: '#CCE7FF',
                                    fontFamily: 'Roboto',
                                    fontWeight: 600,
                                    fontStyle: 'normal',
                                    fontSize: '14px',
                                    lineHeight: '16px',
                                    letterSpacing: '2%',
                                    color: '#000000',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textAlign: col?.align || 'left',

                                }}
                            >
                                {col.caption || ''} {col.value || ""}
                            </TableCell>
                        ))
                        :
                        columnDefs.map((col, colIndex) => (
                            <TableCell
                                key={`dataRow-${col.field}-${index}-${colIndex}`}
                                sx={{
                                    ...col.headerSx,
                                    fontFamily: 'Roboto',
                                    fontWeight: 500,
                                    fontStyle: 'normal',
                                    fontSize: '12px',
                                    lineHeight: '16px',
                                    letterSpacing: '2%',
                                    color: '#444',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                            >
                                {obj?.[col.field] ?? ''}
                            </TableCell>
                        ))
                }
            </>
        )
    }
    return (
        <>
            <TableVirtuoso
                useWindowScroll
                data={tableData?.length === 0 ? [{}] : tableData}
                components={VirtuosoTableComponents}
                fixedHeaderContent={headerContent}
                itemContent={bodyContent}
            />
        </>
    )
}

export default VirtualizedTable